<template lang="pug">
  app-layout
    v-stepper.mx-5.mt-4(:value="step")
      v-stepper-header
        v-stepper-step(step="1") Upload file
        v-divider
        v-stepper-step(step="2") Add tags
        v-divider
        v-stepper-step(step="3") Match fields
        v-divider
        v-stepper-step(step="4") Verify And Finish
      v-stepper-items
        v-stepper-content(step="4")
          v-container.layout(fluid)
            v-layout(column fill-height)
              div.card
                .card-content
                  h2 All Done!
                  div
                    .card-content-column-success
                      .stat-container
                        p
                          v-icon.icon.icon-success(medium color="primary") check_circle
                      div
                        p.success-msg {{importResults.success}} New contacts have been added
                    .card-content-column-errors
                      .stat-container
                        p
                          v-icon.icon.icon-success(medium color="orange darken-2") error
                      div.errors-msg
                        p {{importResults.errors}} Contacts could not be imported
              v-layout(column)
                v-card.card
                  v-data-table#table(
                    :headers="headers"
                    :items="failedRecords"
                    v-if="importResults.errors > 0"
                    disable-initial-sort
                    :rows-per-page-items="rowsPerPage"
                  )
                    template(slot="items" slot-scope="field")
                      td(v-for="value, key in field.item" :class="{'field-error': isFieldWithError(field.item, key)}") {{ value }}
              v-layout(row justify-center align-center)
                v-flex.action-buttons(xs3)
                  router-link(to="/contacts")
                    v-btn(
                      data-cy="summary-view-contacts"
                      @click="clearImportProcess"
                    ).v-btn.primary
                      | View my contacts
                v-flex.action-buttons(xs3)
                  router-link(to="/contacts/import/process")
                    v-btn(
                      data-cy="summary-new-file"
                      @click="clearImportProcess"
                    ).v-btn.primary
                      | Import a new file
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'contact-import-summary',
  mounted() {
    this.clearImportProcess();
    this.setStep(4);
  },
  data() {
    return {
      rowsPerPage: [5, 10, 20, 100, 200],
    }
  },
  methods: {
    ...mapActions('importContacts', ['setStep']),
    ...mapMutations('importContacts', ['clearImportProcess']),
    addAddressRecord(record, addressType, field) {
      if(record.addresses.length == 1) {
        return record.addresses[0][field];
      } else if(addressType.toLowerCase() === "home") {
        return record.addresses[0][field];
      } else if(addressType.toLowerCase() === "main office") {
        return record.addresses[1][field];
      }
    },
    isFieldWithError(field, key) {
      return 'email' == key;
    },
  },
  computed: {
    ...mapState('importContacts', {
      importResults: state => state.importResults,
      contactsFields: state => state.contactsFields,
      fieldsMatch: state => state.fieldsMatch,
      step: state => state.step,
      failedRecords() {
        const filteredFields = [];
        this.importResults.failedRecords.forEach(record => {
          let newRecord = {}
          this.contactsColumns.forEach(field => {
            if(record[field] || record[field] == '') {
              newRecord[field] = record[field];
            } else if(this.fieldsMatch[field]) {
              const { value } = this.fieldsMatch[field];
              if(value === "hotness_id") {
                newRecord[field] = record["hotness_value"];
              } else if(value === "source_id") {
                newRecord[field] = record["source_value"];
              } else if(value.addressType && record.addresses.length > 0) {
                newRecord[field] = this.addAddressRecord(record, value.addressType, value.addressValue);
              } else {
                newRecord[field] = record[value];
              }
            }
          });
          newRecord['error_message'] = record.error_message;
          filteredFields.push(newRecord);
        });
        return filteredFields;
      },
      headers() {
        const headers = this.contactsFields.map(field => ({ text: field, value: field }) );
        headers.push({text: 'Error Message', value: 'error_message'});
        return headers;
      },
      contactsColumns() {
        return this.contactsFields.map(field => field.toLowerCase());
      }
    }),
  },
};
</script>

<style lang="scss" scoped>
@mixin card-content-column{
  display: flex;
  min-width: 450px;
  align-items: center;
  position: relative;
  div.stat-container{
      width: 50px;
      text-align: center;
  }
}
.layout{
  width: 100%;
  .card{
    height: 100%;
    width: 100%;
    max-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon-success{
      font-size: 64px;
    }
    .card-content{
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      h2{
          font-size: 24px;
          font-weight: normal;
      }
      .card-content-column-errors{
          @include card-content-column;
          margin-left: 10%;
          div.errors-msg{
              margin-right: 10px;
              font-size: 18px;
          }
      }
      .card-content-column-success{
          @include card-content-column;
          p.success-msg{
              font-size: 25px;
          }
      }
      .card-content-actions{
          display: flex;
          flex-direction: column;
          button{
              margin-bottom: 16px;
              width: 250px;
          }
      }
    }
    #table {
      height: 100%;
      width: 100%;
      padding: 24px;
      overflow-x: auto;
      /deep/ .v-table__overflow{
        max-height: 300px;
        overflow: scroll;
      }
      thead {
        text-align: left;
      }
    }
    table.v-table {
      thead tr {
        padding: 0;
      }
      tbody td {
        height: 0;
        padding-top: 0;
        white-space: nowrap;
      }
    }
  }
  .action-buttons{
      margin-top : 50px;
      margin-bottom: 16px;
      width: 250px;
      flex-basis: 0;
  }
  .theme--light.v-table tbody tr td, .theme--light.v-table tbody tr:not(:last-child) td {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  table.v-table tbody td {
    height: 0;
    padding-bottom: 5px;
    padding-top: 5px;
  }
  .theme--light.v-stepper {
    background: none;
    display: flex;
    flex-direction: column;
    box-shadow: none;
    .v-stepper__header {
      box-shadow: none;
      flex: 1 1 auto;
    }
    .v-stepper__items {
      flex: 1 1 auto;
    }
    &,
    .v-stepper__items,
    .v-stepper__content,
    .v-stepper__content,
    >>> .v-stepper__wrapper,
    .v-stepper__wrapper > div,
    >>> .stepper-nav-btn {
      height: 100%;
    }
  }
}
.field-error {
  font-weight: bold;
}
</style>